import { userServices } from '../services/usersServices';

import { UserActions, } from '../types/UserActions';
import { UserBody } from '../types/UsersBody';

const usersList = () => (dispatch: any) => {
	const success = (data: UserBody[]): UserActions =>
		({ type: 'USERS_LIST_SUCCESS', data });

	userServices.list().then((res: any) => { dispatch(success(res)) });
}

const newUser = (formData: any) => {
	return userServices.newUser(formData);
}

const assignRole = (formData: any) => {
	return userServices.updateUser(formData);
}


const getUserCount = () => (dispatch: any) => {
	const success = (data: number): UserActions =>
		({ type: 'USERS_LIST_COUNT_SUCCESS', data });

	userServices.userCount().then((res: any) => dispatch(success(res)));
}

const removeUserRole = (id: string, roleId: string, miniLibraryId: string) => {
	return userServices.removeUserRole(id, roleId, miniLibraryId);
}

const updateUser = (formData: any) => {
	return userServices.updateUser(formData);
}

const deleteUser = (userData: any) => {
	return userServices.deleteUser(userData);
}

export {
	usersList,
	newUser,
	assignRole,
	getUserCount,
	removeUserRole,
	updateUser,
	deleteUser
};